import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    IRescheduledDaysInitialState,
    IRescheduledDaysPayload,
} from "../types";
import { GetRescheduledDays } from "./thunk";

const initialState: IRescheduledDaysInitialState = {
    rescheduledDays: [],
    isLoadingRescheduledDays: true,
    selectedRescheduledDaysIDs: [],
};

const rescheduledDaysSlice = createSlice({
    name: "rescheduledDays",
    initialState,
    reducers: {
        setRescheduledDays: (
            state,
            action: PayloadAction<IRescheduledDaysPayload[]>
        ) => {
            state.rescheduledDays = action.payload.filter(
                (item: IRescheduledDaysPayload) => item.kind === "rescheduled"
            );
        },

        deleteRescheduledDays: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.rescheduledDays = state.rescheduledDays.filter(
                (elem) => elem.id !== id
            );
        },

        updateRescheduledDays: (
            state,
            action: PayloadAction<{
                updatedRescheduledDays: IRescheduledDaysPayload;
            }>
        ) => {
            const { updatedRescheduledDays } = action.payload;
            state.rescheduledDays = state.rescheduledDays.map(
                (elem: IRescheduledDaysPayload) => {
                    if (elem.id === updatedRescheduledDays.id) {
                        return {
                            ...elem,
                            ...updatedRescheduledDays,
                        };
                    }
                    return elem;
                }
            );
        },

        setSelectedRescheduledDaysIDs: (
            state,
            action: PayloadAction<number[]>
        ) => {
            state.selectedRescheduledDaysIDs = action.payload;
        },

        addRescheduledDays: (
            state,
            action: PayloadAction<IRescheduledDaysPayload[]>
        ) => {
            state.rescheduledDays.push(...action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetRescheduledDays.pending, (state) => {
                state.isLoadingRescheduledDays = true;
            })
            .addCase(GetRescheduledDays.fulfilled, (state) => {
                state.isLoadingRescheduledDays = false;
            })
            .addCase(GetRescheduledDays.rejected, (state) => {
                state.isLoadingRescheduledDays = false;
            });
    },
});

export const {
    setRescheduledDays,
    setSelectedRescheduledDaysIDs,
    deleteRescheduledDays,
    updateRescheduledDays,
    addRescheduledDays,
} = rescheduledDaysSlice.actions;

export default rescheduledDaysSlice;
